import { faBookmark, faComment } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-regular-svg-icons';
import { faFacebook, faTwitter, faWhatsapp, faLinkedin } from '@fortawesome/free-brands-svg-icons';

const ImpactOfAIAgents = () => {
  return (
    <div className="bg-[#fff] w-full flex flex-col">
      <section
        style={{ backgroundImage: `url('../images/ai-job-automation.jpg')`, backgroundSize: "100% 60vh" }}
        className="hero--container relative flex flex-col justify-center w-full h-[60vh] bg-no-repeat bg-fixed md:bg-origin-border pt-[65px]">
        <p className="text-white p-1.5 rounded-md text-xs font-bold text-center mb-10 bg-blue-500 mx-auto">
          AI, Workforce Impact
        </p>
        <h1 className="text-center text-white text-2xl md:text-5xl font-bold uppercase leading-9">
          The Impact of AI Agents on Job Automation and the Workforce
        </h1>

        <div className="flex justify-center items-center gap-4 mt-10">
          <div className="flex items-center gap-2 text-white">
            <FontAwesomeIcon icon={faClock} className="w-4" />
            <p className="blog-publish-date">27/01/2025</p>
          </div>

          <div className="flex items-center gap-2 text-white">
            <FontAwesomeIcon icon={faComment} className="w-4" />
            <p className="blog-publish-date">8 Comments</p>
          </div>

          <div className="flex items-center gap-2 text-white">
            <FontAwesomeIcon icon={faBookmark} />
            <p className="blog-publish-date">2300 Views</p>
          </div>
        </div>
      </section>

      <section className="body--container w-full px-4 py-8 md:py-10 md:px-12 lg:px-16 xl:px-20 2xl:px-24">
        <div className="mx-auto max-w-screen-md">
          <p className="pb-4 text-justify leading-7">
            Artificial Intelligence (AI) agents are transforming industries worldwide by automating tasks that were once the sole domain of human workers. While this revolution brings efficiency and innovation, it also raises significant concerns about its impact on job markets and the workforce at large.
          </p>

          <img src="../images/ai-job-automation.jpg" alt="" className="mx-auto mt-3 mb-6 w-full" />

          <p className="pb-4 text-justify leading-7">
            One of the primary advantages of AI-driven job automation is increased productivity. AI agents excel in performing repetitive and time-consuming tasks with precision, allowing businesses to reallocate human resources to more strategic and creative roles. For instance, in industries like manufacturing and logistics, AI-powered robots and algorithms streamline operations, resulting in faster output and reduced costs.
          </p>

          <p className="pb-4 text-justify leading-7">
            However, the rapid adoption of AI has sparked fears of job displacement. Many roles that rely on routine and repetitive tasks, such as data entry, customer support, and assembly line work, are at risk of becoming obsolete. This shift necessitates a reevaluation of workforce skills and a focus on reskilling and upskilling programs to prepare workers for new opportunities in a technology-driven landscape.
          </p>

          <p className="pb-4 text-justify leading-7">
            AI also has the potential to create new jobs and industries. From AI ethics specialists to machine learning engineers, the demand for skilled professionals in AI-related fields is growing rapidly. Governments and organizations must invest in education and training to bridge the skill gap and ensure a smooth transition for displaced workers into emerging roles.
          </p>

          <p className="pb-4 text-justify leading-7">
            Another critical aspect is the ethical responsibility of businesses deploying AI. Transparency and accountability are essential to prevent biases in AI algorithms that could negatively impact hiring practices or workplace equality. Collaboration between policymakers, tech companies, and labor organizations is necessary to create guidelines that ensure ethical AI adoption.
          </p>

          <p className="pb-4 text-justify leading-7">
            In conclusion, while AI agents revolutionize job automation, their impact on the workforce is multifaceted. By addressing the challenges of job displacement and prioritizing skill development, society can leverage the benefits of AI while minimizing its drawbacks. The journey ahead requires a balanced approach, embracing innovation while safeguarding the interests of workers worldwide.
          </p>
        </div>
      </section>

      <section className="mb-8">
        <div className="max-w-screen-md mx-auto rounded-md flex justify-between items-center gap-6">
          <div className="flex flex-wrap gap-2">
            <p className="bg-gray-200 text-gray-600 px-2 py-1 rounded-md">AI</p>
            <p className="bg-gray-200 text-gray-600 px-2 py-1 rounded-md">Job Automation</p>
            <p className="bg-gray-200 text-gray-600 px-2 py-1 rounded-md">Workforce</p>
          </div>
          <div className="flex items-center gap-3">
            <div className="flex items-center bg-[#42599E] p-4 rounded-lg text-white mb-2 max-h-1">
              <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faFacebook} /> share
              </a>
            </div>
            <div className="flex items-center bg-[#55ACEE] p-4 rounded-lg text-white mb-2 max-h-1">
              <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faTwitter} /> tweet
              </a>
            </div>
            <div className="flex items-center bg-[#34AF23] p-4 rounded-lg text-white mb-2 max-h-1">
              <a href="https://www.whatsapp.com" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faWhatsapp} /> whatsapp
              </a>
            </div>
            <div className="flex items-center bg-[#0798CF] p-4 rounded-lg text-white mb-2 max-h-1">
              <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faLinkedin} /> linkedin
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ImpactOfAIAgents;